import styled from "styled-components";

export const Flex = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 16px;
`;
